import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Check, KeyRound } from "lucide-react";
import api from "@/lib/api";

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { if (!token) toast.error("Link mancante o non valido"); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    if (pw.length < 10) { toast.error("Almeno 10 caratteri"); return; }
    setBusy(true);
    try {
      await api.post("/auth/password-reset", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      const msg = err.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Errore, riprova");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-bone px-6" data-testid="page-admin-reset">
      <div className="w-full max-w-md bg-white border border-hair p-10">
        {done ? (
          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mx-auto"><Check size={26} className="text-gold" /></div>
            <div className="eyebrow mt-5">Password aggiornata</div>
            <h1 className="font-serif text-3xl mt-3">Tutto pronto.</h1>
            <p className="text-taupe text-sm mt-3">Puoi accedere con la nuova password.</p>
            <button onClick={() => navigate("/admin/login")} className="btn-ink mt-8 w-full" data-testid="reset-go-login">Vai al login</button>
          </div>
        ) : (
        <form onSubmit={submit} data-testid="reset-form">
          <div className="flex items-center gap-3">
            <KeyRound size={18} className="text-gold" />
            <div className="eyebrow">Reimposta password</div>
          </div>
          <h1 className="font-serif text-3xl mt-3">Scegli una nuova password.</h1>
          <p className="text-sm text-taupe mt-3">Almeno 10 caratteri. Il link è valido 2 ore e usabile una sola volta.</p>
          <div className="mt-8 space-y-5">
            <div>
              <Label className="text-xs tracking-[0.14em] uppercase">Nuova password</Label>
              <Input type="password" required minLength={10} value={pw} onChange={(e)=>setPw(e.target.value)} className="rounded-none mt-2" data-testid="reset-pw" />
            </div>
            <div>
              <Label className="text-xs tracking-[0.14em] uppercase">Conferma password</Label>
              <Input type="password" required minLength={10} value={pw2} onChange={(e)=>setPw2(e.target.value)} className="rounded-none mt-2" data-testid="reset-pw2" />
            </div>
          </div>
          <button type="submit" disabled={busy || !token} className="btn-ink w-full mt-8 disabled:opacity-60" data-testid="reset-submit">
            {busy ? "…" : "Reimposta password"}
          </button>
          <div className="mt-6 text-center">
            <Link to="/admin/login" className="text-xs tracking-[0.14em] uppercase text-taupe hover:text-ink">← Torna al login</Link>
          </div>
        </form>
        )}
      </div>
    </div>
  );
}
